import { render, staticRenderFns } from "./configureCustomizedContentModal.vue?vue&type=template&id=08961499&scoped=true"
import script from "./configureCustomizedContentModal.vue?vue&type=script&lang=js"
export * from "./configureCustomizedContentModal.vue?vue&type=script&lang=js"
import style0 from "./configureCustomizedContentModal.vue?vue&type=style&index=0&id=08961499&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08961499",
  null
  
)

export default component.exports